import { Capability } from '../account-api';

export enum DexpEndpointTierGroups {
  Free = 'free', // not an entitlement
  Basic = 'data-points-basic',
  Premium = 'data-points-premium',
  PremiumPlus = 'data-points-premium-plus',
  PropertyEstimate = 'property-estimate-api',
  BuildToApi = 'build-to-api',
}

interface DexpEndpointCategory {
  category: string;
  endpoints: Capability[];
}

export interface DexpEndpointTier {
  tier: string;
  categories: DexpEndpointCategory[];
  capabilities: Capability[];
}
export type DexpEndpointTiers = Record<
  DexpEndpointTierGroups,
  DexpEndpointTier
>;
